import { localStorageLang } from '../constants';
import { SWITCH_LANGUAGE } from './types';

///////////
// Language //
///////////

export function switchLanguage(lang) {

	let request;
	if(typeof lang !== "undefined") {
		request = (parseInt(lang, 10) === 0) ? 1 : 0;
	} else {
		request = localStorage.getItem(localStorageLang) === null ? 0 : parseInt(localStorage.getItem(localStorageLang), 10);
	}

	localStorage.setItem(localStorageLang, request.toString());

	return {
		type: SWITCH_LANGUAGE,
		payload: request
	}
}
